import { ajax } from "@utils";

export const visitRecordService = {
  /**
   * 取得訪客紀錄列表
   * @key SearchConstructionVisitRecordByProperty
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} condition - 查詢條件
   * @returns
   */
  getAll: (constructionUuid, condition) => {
    return ajax
      .get(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/visit-records`,
        {
          params: {
            ...condition
          }
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }

        return res.data;
      });
  },
  /**
   * 取得訪客紀錄資訊
   * @key GetConstructionVisitRecordByProperty
   * @param {number} id - 訪客紀錄 id
   * @returns
   */
  get: id => {
    return ajax
      .get(`${process.env.REACT_APP_API_URL}/property/construction-visit-records/${id}`)
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }

        return res.data;
      });
  },
  /**
   * 更新訪客紀錄資訊
   * @key UpdateConstructionVisitRecordByProperty
   * @param {number} id - 訪客紀錄 id
   * @param {object} info - 訪客紀錄資訊
   * @returns
   */
  update: (id, info) => {
    return ajax
      .put(`${process.env.REACT_APP_API_URL}/property/construction-visit-records/${id}`, {
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          ...info
        })
      })
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  },
  /**
   * 新增訪客紀錄資訊
   * @key CreateConstructionVisitRecordByProperty
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} info - 訪客紀錄資訊
   *
   * @returns
   */
  create: (constructionUuid, info) => {
    return ajax
      .post(
        `${process.env.REACT_APP_API_URL}/property/constructions/${constructionUuid}/visit-records`,
        {
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            ...info
          })
        }
      )
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  },
  /**
   * 刪除訪客紀錄資訊
   * @key DeleteConstructionVisitRecordByProperty
   * @param {number} id - 訪客紀錄 id
   * @returns
   */
  delete: id => {
    return ajax
      .delete(`${process.env.REACT_APP_API_URL}/property/construction-visit-records/${id}`)
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  },
  /**
   * 訪客離場
   * @key LeftConstructionVisitRecordByProperty
   * @param {number} id - 訪客紀錄 id
   * @returns
   */
  left: id => {
    return ajax
      .put(`${process.env.REACT_APP_API_URL}/property/construction-visit-records/${id}/left`, {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(response => response.json())
      .then(res => {
        if (res.status !== 200) {
          return Promise.reject(res.message);
        }
        return res.message;
      });
  }
};
